<template>
  <div>
    <Sidebar
      v-bind:logoSrc="`${this.$cdnUrl}/icon.png`"
      v-bind:logoName="sidebar.logo"
      v-bind:navigationList="navigationList"
      v-on:sidebar-toggle="toggleSpace"
    ></Sidebar>
    <div class="content sidebar-opened" ref="content">
      <router-view
        @setPromptVisibility="updatePromptShowingState"
        @setPromptLoading="updatePromptLoadingState"
        ref="settingsParentComponent"
      ></router-view>
    </div>
    <Confirm
      v-bind:loading="isPromptLoading"
      v-if="isPromptShowing"
      @saveChanges="saveChanges"
      @discardChanges="discardChanges"
    />
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Confirm from "@/components/Confirm.vue";
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
    Sidebar,
    Confirm
  },
  watch: {
    $route () {
      this.updatePromptShowingState(false);
      this.updatePromptLoadingState(false);
    },
    login_queried () {
      if (this.login_queried && !this.authenticated) window.location.href = "/login";
    }
  },
  data() {
    return {
      sidebar: { logo: "ModCord" },
      isPromptShowing: false,
      isPromptLoading: false
    };
  },
   computed: {
    guildId() {
      return this.$route.params.id;
    },
    guild() {
      return this.allGuilds ? this.allGuilds.find(guild => guild.id === this.guildId) : {};
    },
    navigationList() {
      return [
        {
          type: "input",
          text: this.guild ? this.guild.name : "Editing Server",
          tooltipText: this.guild ? this.guild.name : "Editing Server",
          icon: this.guild.icon ? `https://cdn.discordapp.com/icons/${this.guild.id}/${this.guild.icon}.png?size=128` : `${this.$cdnUrl}/icon.png`
        },
        {
          type: "link",
          text: "Config Options",
          tooltipText: "Logger Options",
          icon: "fas fa-info-circle",
          path: `/dashboard/${this.guildId}/config`
        },
        {
          type: "link",
          text: "Member Welcomer",
          tooltipText: "Member Welcomer",
          icon: "fas fa-hand-paper",
          path: `/dashboard/${this.guildId}/welcomer`
        },
        {
          type: "link",
          text: "Logger Options",
          tooltipText: "Logger Options",
          icon: "fas fa-align-left",
          path: `/dashboard/${this.guildId}/logger`
        },
        {
          type: "link",
          text: "Automod Filters",
          tooltipText: "Automod Filters",
          icon: "fas fa-filter",
          path: `/dashboard/${this.guildId}/automod`
        },
        {
          type: "link",
          text: "Auto Punishments",
          tooltipText: "Auto Punishments",
          icon: "fas fa-hammer",
          path: `/dashboard/${this.guildId}/punishments`
        },
        {
          type: "link",
          text: "Server Commands",
          tooltipText: "Server Commands",
          icon: "fas fa-terminal",
          path: `/dashboard/${this.guildId}/commands`
        },
        {
          type: "link",
          text: "Server Security",
          tooltipText: "Server Security",
          icon: "fas fa-shield-alt",
          path: `/dashboard/${this.guildId}/security`
        }
      ]
    },
    ...mapGetters(["id", "avatar", "username", "discriminator", "allGuilds", "authenticated", "login_queried"])
    },
  methods: {
    toggleSpace() {
      const content = this.$refs.content;
      content.classList.toggle("sidebar-opened");
    },
    updatePromptShowingState (isPromptVisible) {
      this.isPromptShowing = isPromptVisible;
    },
    updatePromptLoadingState (isPromptLoading) {
      this.isPromptLoading = isPromptLoading;
    },
    saveChanges () {
      this.$refs.settingsParentComponent.save();
    },
    discardChanges () {
      this.$refs.settingsParentComponent.discard();
    }
  },
  mounted() {
    const availablePaths = this.navigationList.filter(item => item.type === "link");
    if (!availablePaths.map(navItem => this.$route.path.includes(navItem.path)).includes(true)) this.$router.push(availablePaths[0].path);
  }
}
</script>

<style>
:root {
  --small-border-radius: 0.5em;
  --sidebar-open-width: 265px;
  --sidebar-closed-width: 93px;
  --sidebar-closed-button-width: 55px;
  --sidebar-open-button-width: 95.5%;
  --sidebar-animation-duration: 0.5s;
}

.content, .content.sidebar-opened {
  overflow-x: hidden;
  position: absolute;
  height: 100%;
  transition: all .5s;
}

.content {
  width: calc(100% - var(--sidebar-closed-width));
  left: var(--sidebar-closed-width);
}

.content.sidebar-opened {
  width: calc(100% - var(--sidebar-open-width));
  left: var(--sidebar-open-width);
}

@media only screen and (max-width: 650px) {
  .content.sidebar-opened {
    width: calc(100% - var(--sidebar-closed-width));
    left: var(--sidebar-closed-width);
  }
}
</style>
